import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

export function validateForm(formGroup: UntypedFormGroup) {
  Object.keys(formGroup.controls).forEach((field) => {
    const control = formGroup.get(field);
    if (control instanceof UntypedFormControl) {
      control.markAsTouched({ onlySelf: true });
    } else if (control instanceof UntypedFormGroup) {
      validateForm(control);
    }
  });
}
